module.exports = " <a :href=href class=\"btn-custom btn-custom-{{type}}\" _v-5e534912=\"\"> <slot _v-5e534912=\"\"></slot> </a> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-5e534912!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BtnPop.vue
// module id = 152
// module chunks = 0